module.exports = "images/apple-icon-57x57.0f9856cdc3d6152a96f880f3ff136de1.png";